<script setup lang="ts">
// 修改导入语句，直接从Vue和Nuxt导入
import { ref, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useHead } from '#imports';
import { localeMappings } from '~/i18n/config';
import AnalyticsConsent from '~/components/mm/shell/AnalyticsConsent.vue';
import ShellFooter from '~/components/mm/shell/ShellFooter.vue';
import { useInvitationObserver } from '~/composables/useInvitationObserver';

const { locale } = useI18n();
// Auth and i18n hooks require a component setup context. Initialize before pages.
if (import.meta.client) useInvitationObserver();
// Page-specific content languages (for example, guides) retain their own head entry.
useHead(() => ({
  htmlAttrs: { lang: locale.value },
  meta: [{ property: 'og:locale', content: localeMappings.shortToFull[locale.value as keyof typeof localeMappings.shortToFull] || 'en_US' }],
}));
const appIsReady = ref(false);

// 优化挂载流程，将关键初始化提前
onMounted(async () => {
  // 使用nextTick等待DOM更新
  await nextTick();
  
  // 使用requestAnimationFrame延迟非关键初始化
  if (typeof window !== 'undefined') {
    Promise.resolve().then(() => {
      appIsReady.value = true;
    });
  }
});

</script>

<template>
  <div class="app-root">
    <!-- 使用NuxtLayout包装内容 -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ShellFooter v-if="$route.meta.layout === false" />
    
    <!-- 全局 Toast 事件监听器 - 懒加载方式 -->
    <GlobalToastListener v-if="appIsReady" />
    <ClientOnly><AnalyticsConsent /></ClientOnly>

  </div>
</template>

<style>
/* 内联关键CSS，确保首屏渲染时关键样式立即可用 */
:root {
  --bg-color: var(--bg);
  --text-color: var(--text);
}

/* 隐藏Nuxt的默认链接和调试信息 */
.__nuxt-error-page,
.nuxt-progress,
.nuxt-loading,
.nuxt-link-active {
  display: none !important;
}

/* 确保页面背景始终是深色的 */
html, body {
  background-color: var(--bg-color) !important; /* dark:bg-gray-950 */
  color: var(--text-color);
  margin: 0;
  padding: 0;
  text-rendering: optimizeSpeed;
}

/* 添加首屏关键样式 */
.app-root {
  color-scheme: inherit;
  min-height: 100vh;
  width: 100%;
}
</style>
